module.exports = __webpack_public_path__ + "img/DE00895.f600c48f.png";